import type { UserSelectorOption } from "../common/UserSelect/UserSelector";
import type { DAY } from "./types";

// Tabs
export const MEETINGS_TAB = {
	key: "meetings",
	label: "Meetings",
};
export const CALENDAR_TAB = {
	key: "calendar",
	label: "Calendar",
};
export const USAGE_TAB = {
	key: "usage",
	label: "Usage",
};
export const OVERVIEW_TAB = {
	key: "overview",
	label: "Overview",
};
export const MEMBERS_TAB = {
	key: "members",
	label: "Members",
};
export const ONE_ON_ONES = {
	key: "1on1s",
	label: "1-on-1s",
};
export const OLD_TABS_VALUES = [OVERVIEW_TAB, MEMBERS_TAB] as const;
// [GRTH-691] Removed the Usage Tab from the Analytics page
export const TABS_VALUES = [MEETINGS_TAB, CALENDAR_TAB, ONE_ON_ONES, MEMBERS_TAB] as const;

// Filters
export const RANGE_FILTER_VALUES = [14, 30, 60, 90] as const;
export const RANGE_FILTER_VALUES_IN_WEEKS = [4, 8, 12] as const;

export const FILTER_TOOLTIP = "View analytics for the selected person and all people who report into them.";

export const RANGE_FILTER_OPTIONS_IN_WEEKS = RANGE_FILTER_VALUES_IN_WEEKS.map(value => ({
	label: `Past ${value} weeks`,
	value: value.toString(),
}));

export const INCLUDE_REPORTS_RECURSIVELY_OPTIONS = [
	{ label: "Exclude reports", value: "false" },
	{ label: "Include reports", value: "true" },
];

export const ENTIRE_WORKSPACE_SELECTOR_OPTION: UserSelectorOption = { label: "All meetings in workspace", value: "" };
export const ALL_USERS_SELECTOR_OPTION: UserSelectorOption = { label: "All users in workspace", value: "" };
export const FILTER_BY_ORGANIZER_MESSAGE = "Filter by meeting organizer";

// Others
export const days: DAY[] = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const DISABLED_FEATURE_FLAG_ID = "new_analytics_disabled";
export const LABELS = {
	MEETINGS: "Meeting health",
	CALENDAR: "Calendar hygiene",
	USAGE: "Usage stats",
	ENGAGEMENT: "Engagement stats",
};
export const COMMON_GROUP_TITLES = {
	ONE_ON_ONE: "Manager 1-on-1s",
	TWO_PERSON: "Other 1-on-1s",
	GROUP_MEETINGS: "Group meetings",
	LARGE_MEETINGS: "Large meetings",
	EXTERNAL_MEETINGS: "External meetings",
};
export const COMMON_GROUP_DESCRIPTIONS = {
	ONE_ON_ONE: "Meetings between a manager and their direct report.",
	TWO_PERSON: "Other meetings with 2 attendees.",
	GROUP_MEETINGS: "Meetings with 3 to 8 attendees.",
	GROUP_MEETINGS_WITHOUT_LARGE_MEETINGS: "Meetings with more than 3 attendees.",
	LARGE_MEETINGS: "Meetings with more than 8 attendees.",
	EXTERNAL_MEETINGS: "Meetings with external attendees.",
};
